import {
    TRACKING_EVENT_PENDING,
    TRACKING_EVENT_SUCCESS,
    TRACKING_EVENT_ERROR,
    TRACKING_EVENT_CLICK,
    TRACKING_EVENT_IMPRESSION,
    TRACK_EVENT,
} from 'constants/vaix/trackingEvents';
import VAIXService from '../utils/VAIXService';
export function trackClickEvent(
    eventType,
    identifier,
    identifierType,
    location,
    page,
    userId,
    position
) {
    return (dispatch) => {
        dispatch({
            type: TRACKING_EVENT_PENDING,
            payload: true,
        });

        const data = {
            [identifierType]: identifier,
            location: location,
            page: page,
        };

        if (position !== undefined) {
            data.position = position;
        }

        const event = {
            user_id: userId,
            event_type: eventType,
            data: data,
        };

        VAIXService.createTrackerEvent(event)
            .then((res) => {
                dispatch({
                    type: TRACKING_EVENT_SUCCESS,
                    payload: res,
                });
                dispatch({
                    type: TRACKING_EVENT_CLICK,
                    payload: event,
                });
            })
            .catch((error) => {
                dispatch({
                    type: TRACKING_EVENT_ERROR,
                    payload: error.toString(),
                });
            });
    };
}

// export const trackEvent = (eventType, userId) => {
//     return (dispatch) => {
//         dispatch({
//             type: TRACKING_EVENT_PENDING,
//             payload: true,
//         });
//         const event = {
//             event_type: eventType,
//             user_id: userId,
//         };
//         VAIXService.createTrackerEvent(event)
//             .then((res) => {
//                 dispatch({
//                     type: TRACKING_EVENT_SUCCESS,
//                     payload: res,
//                 });
//                 dispatch({
//                     type: TRACK_EVENT,
//                     payload: event,
//                 });
//             })
//             .catch((error) => {
//                 dispatch({
//                     type: TRACKING_EVENT_ERROR,
//                     payload: error.toString(),
//                 });
//             });
//     };
// };
export function trackImpressionEvent(
    eventType,
    eventId,
    location,
    page,
    userId
) {
    return (dispatch) => {
        dispatch({
            type: TRACKING_EVENT_PENDING,
            payload: true,
        });
        const event = {
            user_id: userId,
            event_type: eventType,
            data: {
                events: eventId,
                location: location,
                page: page,
            },
        };
        VAIXService.createTrackerEvent(event)
            .then((res) => {
                dispatch({
                    type: TRACKING_EVENT_SUCCESS,
                    payload: res,
                });
                dispatch({
                    type: TRACKING_EVENT_IMPRESSION,
                    payload: event,
                });
            })
            .catch((error) => {
                dispatch({
                    type: TRACKING_EVENT_ERROR,
                    payload: error.toString(),
                });
            });
    };
}
export function trackImpressionSport(
    eventType,
    sportIds,
    location,
    page,
    userId
) {
    return (dispatch) => {
        dispatch({
            type: TRACKING_EVENT_PENDING,
            payload: true,
        });
        const event = {
            user_id: userId,
            event_type: eventType,
            data: {
                sports: sportIds,
                location: location,
                page: page,
            },
        };
        VAIXService.createTrackerEvent(event)
            .then((res) => {
                dispatch({
                    type: TRACKING_EVENT_SUCCESS,
                    payload: res,
                });
                dispatch({
                    type: TRACKING_EVENT_IMPRESSION,
                    payload: event,
                });
            })
            .catch((error) => {
                dispatch({
                    type: TRACKING_EVENT_ERROR,
                    payload: error.toString(),
                });
            });
    };
}
